import { SafeSubscriber } from './subscriber';
import { Subscription } from './subscription';
import { Observer, ObserverLike } from './observer';
import { Finalizer, Operator } from './interfaces';

export class Observable<T> {
  constructor(
    private readonly source: (subscriber: Observer<T>) => Finalizer | void
  ) {}

  subscribe(observer: ObserverLike<T>): Subscription {
    const subscription = new Subscription();
    const subscriber = new SafeSubscriber(observer, subscription);
    const finalizer = this.source(subscriber);
    if (finalizer) {
      subscription.add(finalizer);
    }
    return subscription;
  }

  // TS is too limited to make it generic - added support for up to 4 operators
  pipe(): Observable<T>;
  pipe<A>(op1: Operator<T, A>): Observable<A>;
  pipe<A, B>(op1: Operator<T, A>, op2: Operator<A, B>): Observable<B>;
  pipe<A, B, C>(
    op1: Operator<T, A>,
    op2: Operator<A, B>,
    op3: Operator<B, C>
  ): Observable<C>;
  pipe<A, B, C, D>(
    op1: Operator<T, A>,
    op2: Operator<A, B>,
    op3: Operator<B, C>,
    op4: Operator<C, D>
  ): Observable<D>;
  // Implementation that handles all cases
  pipe(...operators: Operator<any, any>[]): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let intermediate: Observable<any> = this;
    for (const operator of operators) {
      intermediate = operator(intermediate);
    }
    return intermediate;
  }
}
